export default "__VITE_ASSET__DTJSqxgO__"